import { TriStateCheckbox } from '@/components/ui/tri-state-checkbox';

interface IncludeArchivedCheckboxProps {
  showArchived: boolean | 'only';
  showDeleted: boolean;
  onArchivedChange: (value: boolean | 'only') => void;
  className?: string;
}

/**
 * Shortcut control for the job-list archived-visibility filter. A binary checkbox
 * over the existing `showArchived` state: checked === "All incl. Archived" (`true`).
 * The drawer-only modes (Archived Only = `'only'`, Deleted Only = `showDeleted`) can't
 * be represented by a binary checkbox, so it renders disabled in those states and
 * directs the user to the Filter drawer via the tooltip.
 */
export function IncludeArchivedCheckbox({
  showArchived,
  showDeleted,
  onArchivedChange,
  className = '',
}: IncludeArchivedCheckboxProps) {
  const checked = showArchived === true && !showDeleted;
  const indeterminate = showArchived === 'only';
  const disabled = showArchived === 'only' || showDeleted;

  return (
    <label
      // The label is the tap target, so it carries the 44px minimum. Harmless in
      // the desktop toolbar, where the row is already taller than that.
      className={`flex items-center gap-2 min-h-[44px] text-sm text-gray-600 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} ${className}`}
      title={disabled ? 'Set in Filter → Visibility' : undefined}
    >
      <TriStateCheckbox
        checked={checked}
        indeterminate={indeterminate}
        disabled={disabled}
        title={disabled ? 'Set in Filter → Visibility' : undefined}
        onChange={() => { if (!disabled) onArchivedChange(!checked); }}
      />
      <span className="whitespace-nowrap select-none">Include archived</span>
    </label>
  );
}
